var _defs, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgT446Color(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 446.26 396.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-6{stroke:#fff;stroke-width:16px;}.cls-1,.cls-3,.cls-6{stroke-miterlimit:10;}.cls-2{fill:#734e39;}.cls-3{fill:#bcbec0;stroke:#231f20;}.cls-4,.cls-6{fill:#fff;}.cls-5{fill:#231f20;}.cls-7{fill:#3f5e37;}.cls-8{fill:#375230;}.cls-9{fill:#30472a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "t446-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eagle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.43,268.55c17.91,0,37.84-39.74,37.84-39.74,8.54,6.38,19.11-1.83,19.11-1.83,16.57,6.69,20.4-11.07,20.4-11.07,23.88,3.51,29.09-16.93,29.09-16.93,18.52-.18,17.48-18.89,17.48-18.89C433.11,177,431,160.77,431,160.77c22.46-7.7,15.73-26.27,15.73-26.27,14.77-6.4,13.25-25.79,13.25-25.79v-1.38s-31.48,18.82-53.84,23.38-49.86-.94-49.86-.94l-.58,2.89a108.9,108.9,0,0,1-7.09,15.85c-3.9,6.73-14.32,21.05-21.49,21.05s-8.25-10.2-10.63-15.19-2-31.48-25.62-31.48-23.23,26.48-25.62,31.48-3.47,15.19-10.63,15.19S237,155.24,233.11,148.51a109.5,109.5,0,0,1-7.1-15.85l-.57-2.89s-27.5,5.49-49.86.94-53.84-23.38-53.84-23.38v1.38S120.22,128.1,135,134.5c0,0-6.73,18.57,15.73,26.27,0,0-2.13,16.25,15.63,19.32,0,0-1,18.71,17.48,18.89,0,0,5.21,20.44,29.09,16.93,0,0,3.83,17.76,20.4,11.07,0,0,10.57,8.21,19.11,1.83C252.43,228.81,273.52,268.56,291.43,268.55Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.43,268.55c17.91,0,37.84-39.74,37.84-39.74,8.54,6.38,19.11-1.83,19.11-1.83,16.57,6.69,20.4-11.07,20.4-11.07,23.88,3.51,29.09-16.93,29.09-16.93,18.52-.18,17.48-18.89,17.48-18.89C433.11,177,431,160.77,431,160.77c22.46-7.7,15.73-26.27,15.73-26.27,14.77-6.4,13.25-25.79,13.25-25.79v-1.38s-31.48,18.82-53.84,23.38-49.86-.94-49.86-.94l-.58,2.89a108.9,108.9,0,0,1-7.09,15.85c-3.9,6.73-14.32,21.05-21.49,21.05s-8.25-10.2-10.63-15.19-2-31.48-25.62-31.48-23.23,26.48-25.62,31.48-3.47,15.19-10.63,15.19S237,155.24,233.11,148.51a109.5,109.5,0,0,1-7.1-15.85l-.57-2.89s-27.5,5.49-49.86.94-53.84-23.38-53.84-23.38v1.38S120.22,128.1,135,134.5c0,0-6.73,18.57,15.73,26.27,0,0-2.13,16.25,15.63,19.32,0,0-1,18.71,17.48,18.89,0,0,5.21,20.44,29.09,16.93,0,0,3.83,17.76,20.4,11.07,0,0,10.57,8.21,19.11,1.83C252.43,228.81,273.52,268.56,291.43,268.55Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M322.94,168.05",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289.85,130.27c21.71-.43,20.84,27.14,23,31.26s5,5,5,7.82-4.77,5.42-4.77,5.42l-3-5s.43,5.43-1.74,7.82L306.13,180l-1.08-6.51s-.87,4.34-3.48,6.51-10.72,12.16-10.72,12.16-9.12-10-11.72-12.16-3.48-6.51-3.48-6.51L274.57,180l-2.17-2.38c-2.17-2.39-1.74-7.82-1.74-7.82l-3,5s-4.77-2.6-4.77-5.42,2.82-3.69,5-7.82,1.3-31.69,23-31.26",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274.47,142.86s.72,9.12,6.29,9.26,10.73-11,10.14-11.94c-.43-.68-6,3.12-8.22,3s-.61-3.33-3.36-3A9.17,9.17,0,0,0,274.47,142.86Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M307.23,142.86s-.72,9.12-6.3,9.26-10.72-11-10.13-11.94c.43-.68,6,3.12,8.22,3s.61-3.33,3.36-3A9.17,9.17,0,0,1,307.23,142.86Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M286.15,151.79a4.39,4.39,0,0,1,4.45-4.15c4.24-.1,4.95,4.15,4.95,4.15L290.85,167Z",
    transform: "translate(-87.9 -93.23)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tent"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M200,279.63c-9.49,27.87-69.4,142.84-98.51,191.87l104.33,6L289,481.35H521.84L470.33,365.73s-27.17-68.84-30.49-86.1Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M521.84,481.35c-30.3-.27-232.82,0-232.82,0L207,279.63H439.84C465.68,365.54,494.07,418.38,521.84,481.35Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "195.93 388.27 122.6 384.27 114.6 188.77 195.93 388.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M101.5,471.5l104.33,6-7-195.5C171.5,351.5,101.5,471.5,101.5,471.5Z",
    transform: "translate(-87.9 -93.23)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Tent_Text_OUTLINED",
    "data-name": "Tent Text OUTLINED"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.49,365H257.9l-7.35-16.75,11-47.93h19l21.28,48.51h10.86l7.1,16.17H309l7.09,16.16H297.59Zm-7.09-16.17-10.79-24.6-5.72,24.6Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M357.85,365H325.26l-7.35-16.75,11-47.93h19l21.28,48.51h10.86l7.1,16.17H376.32l7.09,16.16H365Zm-7.09-16.17L340,324.19l-5.72,24.6Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M386.56,329.85,392,300.28h21.73l-5.47,26.91a14.24,14.24,0,0,1,3.33-.35c12.92,0,28.62,10.28,35.11,25.07,8,18.24.07,30.37-15.79,30.37-15.21,0-33.69-11.9-41.24-29.1C385.93,344.75,385.23,337.47,386.56,329.85Zm36.26,33.37c5.76,0,7.21-4.62,4.68-10.39s-8-10.39-13.8-10.39-7.2,4.62-4.67,10.39S417.06,363.22,422.82,363.22Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M282.51,393h3.7l6.18,14.1H288.7Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M295,398.76l3.67,8.36h-3.51L289,393h3.7l8.66,8.08L297.77,393h3.5l6.19,14.1H304Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M303.93,393h5a11.94,11.94,0,0,1,10.4,7c1.76,4,0,7.11-4.33,7.11h-4.87Zm5.06,3.33,3.27,7.45h1.42c2.16,0,3-1.55,2.06-3.73a6.17,6.17,0,0,0-5.33-3.72Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M318.42,393h3.7l6.19,14.1h-3.7Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M343.75,407.12h-4l-1.84-2.41h-4.7l.29,2.41h-3.79l-1-14.1h3.6Zm-11.36-9.69.49,4.26h2.74Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M344.92,398.76l3.66,8.36h-3.5L338.89,393h3.7l8.66,8.08L347.7,393h3.51l6.19,14.1h-3.51Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M372.75,407.12h-4l-1.84-2.41h-4.7l.28,2.41h-3.79l-1-14.1h3.6Zm-11.36-9.69.48,4.26h2.75Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M367.89,393h5.93a8.11,8.11,0,0,1,7.32,4.94c1.3,3,.07,5-3.06,5h-2.22l1.82,4.13h-3.61Zm6.6,6.85h2c1.16,0,1.56-.76,1.1-1.81a3,3,0,0,0-2.69-1.82h-2Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M387.38,392.82c4,0,8.32,3.12,10.11,7.19s.13,7.32-3.86,7.32-8.33-3.13-10.11-7.2S383.38,392.82,387.38,392.82Zm4.76,11c2,0,2.7-1.61,1.77-3.73a6,6,0,0,0-5-3.72c-2,0-2.71,1.61-1.78,3.72A6.05,6.05,0,0,0,392.14,403.8Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M402.69,407.12,396.5,393h3.61l4.68,10.68h6.06l1.51,3.42Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M407.78,393h3.7l6.18,14.1H414Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M422,398.48c2.1.81,4.59,2.08,5.63,4.45s-.08,4.4-3.06,4.4a11.28,11.28,0,0,1-6.22-2.22l1-2.42a8.65,8.65,0,0,0,4,1.55c.66,0,1-.36.75-.88s-1-1.15-3.72-2.18a8.1,8.1,0,0,1-4.85-4.17c-1.06-2.44.08-4.19,3-4.19a10.47,10.47,0,0,1,5.52,1.91l-1,2.42a6.27,6.27,0,0,0-3.11-1.25c-.74,0-1,.38-.78.81C419.43,397.33,420,397.69,422,398.48Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M432.17,409.74l-2.34-6.64h3.6l1.4,6.64Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M436.72,393h3.7l6.18,14.1h-3.69Z",
    transform: "translate(-87.9 -93.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M449.19,398.76l3.67,8.36h-3.51L443.16,393h3.7l8.66,8.08L452,393h3.5l6.19,14.1h-3.51Z",
    transform: "translate(-87.9 -93.23)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BSA_Logo",
    "data-name": "BSA Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M406.27,477.32a12.7,12.7,0,0,0,2.51-3.71,17.05,17.05,0,0,0,.69-3.95,11.92,11.92,0,0,0,6.67,2.29c3.87.05,5.25-2.33,3.55-5.74-2.17-4.34-8.05-6.72-8.05-6.72s2.24,4.1-.49,4.48c-2.11.29-4.41-2.15-4.41-2.15s1.65-.63.75-2.87a4.65,4.65,0,0,0-3.17-2.73s-3.24-9.88,4.49-8c5.59,1.34,7.44,8.77,7.44,8.77s9.38-3.43,1.48-15.73c-6.32-9.86-17.24-10.44-20.51-6.87,0,0-2.64-5.4-9.87-11.19A131.54,131.54,0,0,1,375.81,412s.15,7.14-1.12,11.17a17.39,17.39,0,0,0,.57,11.19c-6.61-3.57-17-3-14.1,6.87C364.74,453.53,377.3,457,377.3,457s-5.07-7.43-.73-8.77c6-1.85,12,8,12,8s-1.84.45-.63,2.73a6.14,6.14,0,0,0,3.43,2.87A2.09,2.09,0,0,1,389,464c-3.09-.38-4.67-4.48-4.67-4.48a5.35,5.35,0,0,0-1.78,6.72,9.72,9.72,0,0,0,8.9,5.74c3.83-.05,4.53-2.29,4.53-2.29a54.16,54.16,0,0,0,4.38,3.95A48.7,48.7,0,0,0,406.27,477.32Z",
    transform: "translate(-87.9 -93.23)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT446Color);
export default __webpack_public_path__ + "static/media/t446-color.6d70e6613d7721e4953d3baa04d1207e.svg";
export { ForwardRef as ReactComponent };